const ACTION_KEYS = {
  CUSTOMER_SERVICE_CHAT: 'customerServiceChat',
  EXPLORE_SUBJECTS: 'exploreSubjects',
  FREE_MONTH_AND_REQUEST_TUTOR: 'freeMonthAndRequestTutor',
  PAY_AS_YOU_GO: 'payAsYouGo',
  REDEEM_FREE_MONTH: 'redeemFreeMonth',
  REPLACE_TUTOR: 'replaceTutor',
} as const;

export default ACTION_KEYS;
